module.exports = __webpack_public_path__ + "img/cloth_g1_item_15.70997ec3.svg";